'use strict';

angular.module('licensure.services')
    .factory('Complaints', ['$http', '$q', function ($http, $q) {
        return {
            get: function (args) {
                var d = $q.defer();

                $http.get(apiLocation + '/api/Complaints', {
                    params: args
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                        // handle error
                    });

                return d.promise;
            },

            getFilter: function (filter, timeout) {
                var d = $q.defer();

                $http.post(apiLocation + '/api/Complaints/getFilter', filter, {
                    timeout: (timeout != null ? timeout.promise : null)
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                        // handle error
                    });

                return d.promise;
            },

            getCount: function (filter, timeout) {
                var d = $q.defer();

                $http.post(apiLocation + '/api/Complaints/getCount', filter, {
                    timeout: (timeout != null ? timeout.promise : null)
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                        // handle error
                    });

                return d.promise;
            },

            getByID: function (id) {
                var d = $q.defer();

                $http.get(apiLocation + '/api/Complaints/' + id, {
                    params: {

                    }
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            getByUserID: function(user_id, detail, enterprise_id) {
                var d = $q.defer();

                $http.get(apiLocation + '/api/Complaints/getByUserID', {
                    params: {
                        user_id: user_id,
                        detail: detail,
                        enterprise_id: enterprise_id
                    }
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            save: function (complaint) {
                var d = $q.defer();

                var method = 'POST';
                var url = apiLocation + '/api/Complaints/';
                if (!isUndefined(complaint.id)) {
                    method = 'PUT'
                    url += complaint.id
                }

                $http({
                    method: method,
                    url: url,
                    data: {
                        complaint: complaint,
                        users: complaint.users,
                        services: complaint.services,
                        vehicles: complaint.vehicles,
                        alcohol_substances_mental_health: complaint.alcohol_substances_mental_health
                    }
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            delete: function (id) {
                var d = $q.defer();

                $http.delete(apiLocation + '/api/Complaints/' + id, {
                    params: {

                    }
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            bulkAction: function (complaintIDs, value, code) {
                var d = $q.defer();

                $http.post(apiLocation + '/api/Complaints/bulkAction', {
                    complaintIDs: complaintIDs,
                    value: value,
                    code: code
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                        // handle error
                    });

                return d.promise;
            },

            getAlcoholSubstancesMentalHealthFields: function () {
                var d = $q.defer();

                $http.get(apiLocation + '/api/complaints/getAlcoholSubstancesMentalHealthFields', {
                    params: {

                    }
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                        // handle error
                    });

                return d.promise;
            },

            getDomesticViolenceFields: function () {
                var d = $q.defer();

                $http.get(apiLocation + '/api/complaints/getDomesticViolenceFields', {
                    params: {
                    }
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                        // handle error
                    });

                return d.promise;
            },

            checkCategoryAutoNumber: function (categoryId) {
                var d = $q.defer();

                $http.get(apiLocation + '/api/complaints/categoryAutoNumber/' + categoryId, {
                    params: {
                    }
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                        // handle error
                    });

                return d.promise;
            },
           
            getEnterpriseInvestigationSettings: function () {
                var d = $q.defer();

                $http.get(apiLocation + '/api/complaints/getEnterpriseInvestigationSettings', {
                    params: {
                    }
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                        // handle error
                    });

                return d.promise;
            },

            printInvestigation: function (printInvestigationModel) {
                var d = $q.defer();

                $http.get(apiLocation + '/api/InvestigationsModule/Investigation/print', {
                    params: printInvestigationModel
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                        // handle error
                    });

                return d.promise;
            }
        }
    }])
;